import React from 'react';
import moment from 'moment-timezone';
import { ApiMixin } from 'mixins';
import LeadCard from 'components/leadCard';
import LoadingIndicator from 'components/loadingIndicator';

export default React.createClass({
    mixins: [ApiMixin],

    getInitialState() {
        return {
            loading: true,
            leads: [],
        };
    },

    componentDidMount() {
        this.api.request('/api/leads', {
            method: 'GET',
            success: (data) => {
                this.setState({
                    loading: false,
                    leads: data.map((lead) => {
                        const formatted = lead;
                        formatted.event.date = moment(lead.event.date);
                        return formatted;
                    }),
                });
            },
        });
    },

    render() {
        if (this.state.loading) {
            return (
                <div className="page-container">
                    <div className="page-header"><h2>My Leads</h2></div>
                    <div className="my-events full-width"><LoadingIndicator /></div>
                </div>
            );
        }

        return (
            <div className="page-container">
                <div className="page-header">
                    <h2>My Leads</h2>
                </div>

                <div className="my-events full-width">
                    <div className="event-list">
                        {this.state.leads.map(lead => <LeadCard key={`lead${lead.id}`} lead={lead} />)}

                        {!this.state.leads.length && <div className="no-events-message">
                            Looks like you don{'\''}t have any event leads yet. Stay tuned!
                        </div>}
                    </div>
                </div>
            </div>
        );
    },
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/leads.jsx